export default {
  GET: 'GET'
};
